import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
  },
  loader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('mobile')]: {
      marginLeft: theme.spacing(4),
      justifyContent: 'unset',
    },
  },
  emptyLabel: {
    display: 'flex',
    padding: [theme.spacing(1)],
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    backgroundColor: theme.palette.colors.warning,
    [theme.breakpoints.up('mobile')]: {
      marginTop: theme.spacing(2),
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentDashboard/components/FavoriteLoanOfficersList/useStyles.js